import { HTTPInstanceWithPrefix } from '@/lib/http/http-instance-with-prefix'
import { SCHEDULE_ENDPOINT } from '../config'
import { ScheduleWeekDto, UpsertScheduleWeekDto } from './ScheduleAPI.model'

/**
 * REST client for the schedule. Paths are prefixed with
 * `/restaurants/{restaurantId}` by HTTPInstanceWithPrefix.
 *
 * The week is treated as ONE document, like the floor plan: read it whole,
 * write it whole. A roster is edited by nudging many shifts around, so a
 * request per nudge would both hammer the API and persist half-finished states
 * that the user is still dragging.
 */
class ScheduleAPI {
  /** GET the roster for the week starting on `weekStart` (a Monday). */
  static getWeek = (weekStart: string): Promise<ScheduleWeekDto> =>
    HTTPInstanceWithPrefix.get(`${SCHEDULE_ENDPOINT}?weekStart=${weekStart}`).then(
      response => response.data
    )

  /**
   * PUT the whole week. Replaces what is stored, shifts absent from the
   * payload are removed. Returns the persisted week so the client can adopt
   * backend-assigned ids.
   */
  static updateWeek = (
    week: UpsertScheduleWeekDto
  ): Promise<ScheduleWeekDto> =>
    // weekStart travels in the query string as well as the body: it is the
    // destructive scope of this call, and in an access log a bare PUT /shifts
    // reads like "replace every shift ever".
    HTTPInstanceWithPrefix.put(
      `${SCHEDULE_ENDPOINT}?weekStart=${week.weekStart}`,
      week
    ).then(response => response.data)
}

export default ScheduleAPI
